import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconDeliveryBox';
/** Renders an SVG icon. */
const SvgDeliveryBox = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.232 4.36A1 1 0 0 1 10 4h12a1 1 0 0 1 .768.36l5 6A1 1 0 0 1 28 11v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V11a1 1 0 0 1 .232-.64zM10.468 6l-3.333 4H15V6zM17 6v4h7.865l-3.333-4zm9 6H6v14h20zm-9 6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1zm2 1v3h3v-3zM8 19a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1"
      />
    </svg>
  );
};
SvgDeliveryBox.displayName = displayName;
export default SvgDeliveryBox;
